module.exports = __webpack_public_path__ + "site/img/57.870d96dc.jpg";